import { render, staticRenderFns } from "./ProjectAccountingItemEdit.vue?vue&type=template&id=488dbe08"
import script from "./ProjectAccountingItemEdit.vue?vue&type=script&lang=js"
export * from "./ProjectAccountingItemEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports